import CityPageTemplate from "../city-template/CityPageTemplate";
import { friscoConfig } from "./data";

export default function FriscoPage() {
  return <CityPageTemplate config={friscoConfig} />;
}